import React from "react";

const QOLForm = ({ formData, handleChange }) => {
    const questions = [
        { id: "q1", title: "1. Material comforts home, food, conveniences, financial security" },
        { id: "q2", title: "2. Health - being physically fit and vigorous" },
        { id: "q3", title: "3. Relationships with parents, siblings & other relatives- communicating, visiting, helping" },
        { id: "q4", title: "4. Having and rearing children" },
        { id: "q5", title: "5. Close relationships with spouse or significant other" },
        { id: "q6", title: "6. Close friends" },
        { id: "q7", title: "7. Helping and encouraging others, volunteering, giving advice" },
        { id: "q8", title: "8. Participating in organizations and public affairs" },
        { id: "q9", title: "9. Learning- attending school, improving understanding, getting additional knowledge" },
        { id: "q10", title: "10. Understanding yourself - knowing your assets and limitations - knowing what life is about" },
        { id: "q11", title: "11. Work - job or in home" },
        { id: "q12", title: "12. Expressing yourself creatively" },
        { id: "q13", title: "13. Socializing - meeting other people, doing things, parties, etc" },
        { id: "q14", title: "14. Reading, listening to music, or observing entertainment" },
        { id: "q15", title: "15. Participating in active recreation" },
        { id: "q16", title: "16. Independence, doing for yourself" }
    ];

    const options = [
        { value: 7, label: "Delighted" },
        { value: 6, label: "Pleased" },
        { value: 5, label: "Mostly Satisfied" },
        { value: 4, label: "Mixed" },
        { value: 3, label: "Mostly Dissatisfied" },
        { value: 2, label: "Unhappy" },
        { value: 1, label: "Terrible" }
    ];

    const calculateTotal = () => {
        return questions.reduce((sum, q) => sum + (parseInt(formData[q.id] || 0, 10)), 0);
    };

    const totalScore = calculateTotal();

    return (
        <>
            {/* Sticky Guidelines Button */}
            <div className="row mb-4 position-sticky top-0 bg-white pt-3" style={{ zIndex: 10 }}>
                <div className="col-md-3">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm w-100"
                        data-bs-toggle="modal"
                        data-bs-target="#qolGuidelines"
                    >
                        <i className="ri-information-line me-2"></i>
                        QOLS Guidelines & Scoring
                    </button>
                </div>
            </div>
            <div className="p-3" style={{ maxHeight: "60vh", overflowY: "auto", scrollbarWidth: "thin" }}>

                <div className="accordion" id="qolAccordion">
                    {/* Client Information */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#clientInfo">
                                Client Information
                            </button>
                        </h2>
                        <div id="clientInfo" className="accordion-collapse collapse show">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="clientName"
                                                value={formData.clientName || ""}
                                                onChange={handleChange}
                                                readOnly={!!formData.patientId} // ⭐ ADD THIS PROPERTY TO SECURE INPUT BOX ⭐
                                            />
                                            <label>Client Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="diagnosis" value={formData.diagnosis || ""} onChange={handleChange} />
                                            <label>Diagnosis</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="assessedBy" value={formData.assessedBy || ""} onChange={handleChange} />
                                            <label>Assessed By</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* QOL Items - All in one collapsible section */}
                    <div className="accordion-item mb-5 shadow-sm rounded">
                        <h2 className="accordion-header d-flex align-items-center mb-3">
                            <button
                                className="accordion-button fw-semibold"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#qolSection"
                            >
                                Quality of Life Scale (QOLS) – 16 Items
                            </button>

                            {/* Info Button (round) */}
                            <div className="d-flex align-items-center mx-2">
                                <button
                                    type="button"
                                    className="btn btn-sm rounded-circle"
                                    style={{ width: 32, height: 32 }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#qolInstructionsModal"
                                >
                                    <i className="ri-information-line fs-6"></i>
                                </button>
                            </div>
                        </h2>

                        <div id="qolSection" className="accordion-collapse collapse show">
                            <div className="accordion-body">

                                {/* Each QOL Item - Collapsible */}
                                {questions.map((q) => (
                                    <div className="accordion-item mb-3 shadow-sm rounded" key={q.id}>
                                        <h2 className="accordion-header">
                                            <button
                                                className="accordion-button collapsed fw-medium"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#item_${q.id}`}
                                            >
                                                {q.title}
                                            </button>
                                        </h2>

                                        <div id={`item_${q.id}`} className="accordion-collapse collapse">
                                            <div className="accordion-body pt-3">
                                                <div className="row g-4">
                                                    {options.map((opt) => (
                                                        <div className="col-md-4" key={opt.value}>
                                                            <div className="form-check mb-2">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name={q.id}
                                                                    id={`${q.id}_opt${opt.value}`}
                                                                    value={opt.value}
                                                                    checked={formData[q.id] === String(opt.value)}
                                                                    onChange={handleChange}
                                                                />
                                                                <label className="form-check-label fw-medium d-flex align-items-start"
                                                                    htmlFor={`${q.id}_opt${opt.value}`}>
                                                                    <span className="text-primary fw-bold me-3">{opt.value}</span>
                                                                    <span>{opt.label}</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>

                {/* Guidelines Modal */}
                <div className="modal fade" id="qolGuidelines" tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <p className="small">{/* Full content from PDF */}
                                    This form of the Quality of Life Scale (QOLS) has 16 items rather than the 15 found in the original Flanagan version. Item #16, “Independence, doing for yourself” was added after a qualitative study indicated that the instrument had content validity in chronic illness groups but that it needed an item that reflected the importance to these people of remaining independent and able to care for themselves.
                                </p>
                                <p className="small">
                                    The instrument is scored by summing the items to make a total score. Subjects should be encouraged to fill out every item even if they are not currently engaged in it. (e.g. they can be satisfied even if they do not currently participate in organizations. Or they can be satisfied about not having children.) Missing data can be treated by entering the mean score for the item.
                                </p>
                                <p className="small">
                                    If you wish to compare scores in your groups with any scores that have been published, please be aware that most of the Burckhardt references published so far use the 15 item scale. More recent and forthcoming publications all use the 16 item scale. So be sure to check the methods section of the reference before comparing your means to published ones.
                                </p>
                                {/* <p className="small"><strong>Contact:</strong> Carol S. Burckhardt, PhD, RN, Professor of Mental Health Nursing, Oregon Health & Science University</p>
                            <p className="small"><strong>References:</strong></p>
                            <ul className="small">
                                <li>Burckhardt CS, Woods SL, Schultz AA, Ziebarth DM (1989). Quality of life of adults with chronic illness: A psychometric study. Research in Nursing and Health, 12, 347-354.</li>
                                <li>Burckhardt, CS, Clark SR, Bennett RM (1993). Fibromyalgia and quality of life: A comparative analysis. Journal of Rheumatology, 20, 475-479.</li>
                                <li>Flanagan JC (1978). A research approach to improving our quality of life. American Psychologist, 33, 138-147.</li>
                                <li>Flanagan JC (1982). Measurement of quality of life: Current state of the art. Archives of Physical Medicine and Rehabilitation, 63, 56-59.</li>
                            </ul> */}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* QOL Instructions Modal (NEW) */}
                <div className="modal fade" id="qolInstructionsModal" tabIndex="-1">
                    <div className="modal-dialog modal-md modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <p className="small">
                                    Please read each item and circle the number that best describes how satisfied you are at this time.
                                    Please answer each item even if you do not currently participate in an activity or have a relationship.
                                    You can be satisfied or dissatisfied with not doing the activity or having the relationship.
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};

export default QOLForm;